<ng-container *ngIf="model">
  <entity-icon
    data-cy="filter-suggestion-icon"
    class="suggestions-item-icon"
    [model]="model.icon || defaultIcon"
    [size]="'16px'"
  ></entity-icon>
  <result-title data-cy="filter-suggestion-title" [model]="{ text: model.title }"></result-title>
</ng-container>
